import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import classnames from "classnames";

import Styles from "components/menu/ToSite.module.scss";

class ToSite extends Component {

    render () {
        return (
            <a href={"https://glambox.com.br/"} className={classnames(Styles["tosite"])} target={"_blank"}>
                <svg viewBox="0 0 48 48" height="100%" width="100%">
                    <rect x="0" y="0" width="48" height="48"></rect>
                    <path d="M23.999,3.477l-2.066,2.067l0.016,0l-16.96,16.96l-1.505,1.504l0.879,0.877l17.573,17.571l2.066,2.067l0.826,-0.823c0.022,-0.018 0.045,-0.034 0.066,-0.052l14.425,-14.43l1.775,-1.772l-0.869,-0.87l-0.011,-0.011l-14.199,-14.197l-2.049,-2.052l-0.845,0.847l-0.036,0.031l-11.913,11.911l-0.87,0.872l1.427,1.427l12.27,12.272l1.749,-1.76l-11.937,-11.941l10.159,-10.157l13.61,13.612l-13.576,13.57l-17.004,-17.008l17.004,-17.005l18.761,18.762l1.751,-1.759l-18.46,-18.46l-2.057,-2.053Z"></path>
                </svg>
                <span>Voltar para a <strong>home da Glambox</strong></span>
            </a>
        )
    }
}

export {
    ToSite
  };